import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [waitlistCount, setWaitlistCount] = useState(0);

  useEffect(() => {
    axios.get(`${API}/newsletter/count`).then((r) => setWaitlistCount(r.data.count)).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email });
      if (res.data.status === "exists") {
        toast.info("You're already on the list!");
      } else {
        setWaitlistCount((c) => c + 1);
        toast.success("You're on the VIP list!", { description: "20% off your first order when we launch." });
      }
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="py-20 sm:py-28 bg-[#F0EDE8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl mx-auto text-center">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#8B6F47] mb-4" style={{ fontStyle: "normal" }}>
            VIP Early Access
          </p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tighter text-[#0A0A0A] mb-3">
            Get 20% Off Your First Order
          </h2>
          <p className="text-sm text-[#888] tracking-wide mb-4 leading-relaxed">
            Join the waitlist. Be first in line when we drop.
          </p>

          {waitlistCount > 0 && (
            <p data-testid="waitlist-counter" className="text-xs tracking-[0.15em] uppercase text-[#8B6F47] mb-8" style={{ fontStyle: "normal" }}>
              {waitlistCount} {waitlistCount === 1 ? "person" : "people"} on the waitlist
            </p>
          )}

          <form onSubmit={handleSubmit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto mb-4">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email" required data-testid="newsletter-email-input"
              className="flex-1 bg-white border border-[#E5E5E5] text-[#0A0A0A] placeholder:text-[#aaa] px-5 py-3.5 text-sm tracking-wide focus:outline-none focus:border-[#0A0A0A] transition-colors"
              style={{ fontStyle: "normal" }} />
            <button type="submit" disabled={submitting} data-testid="newsletter-submit"
              className="bg-[#0A0A0A] text-white px-8 py-3.5 text-xs tracking-[0.2em] uppercase hover:bg-[#1a1a1a] transition-colors active:scale-[0.98] disabled:opacity-50"
              style={{ fontStyle: "normal" }}>
              {submitting ? "..." : "Join Waitlist"}
            </button>
          </form>
          <p className="text-[10px] text-[#aaa] tracking-wide" style={{ fontStyle: "normal" }}>
            No spam, ever. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </section>
  );
}
